<template>
  <div>
    <div class="row-fluid">
      <!--最新活动-->
      <div class="span12 text-left">
        <div class="jumbotron bg_zhi">
          <div class="container">
            <div class="row" style="height: 100px"></div>
          </div>
        </div>

        <!--最新活动-->
        <div class="span12 text-left">
          <div class="page-header">
            <div class="row">
              <div class="col-6">
                <h4>{{ $route.name }}</h4>
              </div>
              <div class="col-6 text-right" @click="$router.push('index')">
                <h6 class="text-muted">
                  <samp
                    style="
                      color: #505153;
                      background: #f3f4f8;
                      border: 0;
                      padding: 5px 8px 4px 10px;
                      border-radius: 15px;
                    "
                    >主页></samp
                  >
                </h6>
              </div>
            </div>
          </div>

          <div
            style="margin-top: 20px"
            class="jumbotron_c t_20"
            v-for="(item, index) in list_1"
            :key="index"
            @click="$router.push({ path: 'show_zhi', query: { id: item.id } })"
          >
            <div class="row">
              <div class="col-3" style="padding-right: 0px">
                <div style="padding: 10px 0px 10px 10px">
                  <img
                    style="max-width: 70px; height: 70px"
                    :src="item.imgages_a"
                    v-if="item.imgages_a"
                    title="暂无图片"
                  />
                  <div class="imgss" v-else>暂&nbsp;无<br />图&nbsp;片</div>
                </div>
              </div>
              <div class="col-9">
                <h5 class="h5_t_5">
                  <span
                    class="label label-primary label_50"
                    style="padding-top: 4px"
                    >{{ item.label }}</span
                  >
                  &nbsp;{{ item.describe }}
                </h5>
                <footer
                  class="blockquote-footer"
                  style="
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                  "
                >
                  {{ item.title }}
                </footer>
                <h5
                  class="text-right"
                  style="margin-bottom: 0px; padding-top: 3px"
                >
                  <span class="label label-primary-j1">详细信息</span>
                </h5>
              </div>
            </div>
          </div>
        </div>
        <button
          v-if="count > page * 10"
          @click="moreShow"
          class="btn3"
          style="
            display: block;
            margin: 15px auto 0;
            outline: none;
            color: #666;
            width: 50%;
            background-color: #eee;
            height: 40px;
          "
        >
          更多数据
        </button>
        <div v-else style="text-align: center; margin-top: 15px">已无更多</div>
        <div style="height: 30px"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      page: 0,
      count: 0,
      list_1: [],
    };
  },
  methods: {
    list_data(p) {
      // 点击查询更多
      this.$api
        .getAPI("data/info/?type_id=20201107&state=1", {
          page: p,
        })
        .then((res) => {
          var db = res.data.data.data[0];
          console.log(db);
          this.count = db.page.count;
          this.page = db.page.page;
          for (let i = 0; i < db.models.length; i++) {
            this.list_1.push(db.models[i]);
          }
        });
    },
    //分页数据
    moreShow() {
      var c = this.page * 10;
      if (c < this.count) {
        this.page = this.page + 1;
        this.count = this.page * 10;
        this.list_data(this.page);
      }
    },
  },
  mounted() {
    this.list_data(1);
  },
};
</script>
<style scoped>
.btn1 {
  border: none;
  outline: 0;
  background: none;
}

.top-fluid {
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}

.switch {
  outline: none !important;
  margin-left: -6px;
  margin-right: 15px;
  background: none;
  color: #7b7b7b;
  border: none;
  font-size: 14px;
  text-align: left !important;
}

.jumbotron {
  padding: 2rem 2rem;
  margin-bottom: 2rem;
}

.label_50 {
  border-radius: 50px/50px;
}

.page-header {
  margin: 25px 0 0px;
}

.h5_t_5 {
  margin-top: 15px;
}

.b_t_5 {
  padding-top: 6px;
}

.border_ {
  background: #002752;
}

.bg_zhi {
  background: url(https://img.hsnms.com/20211201/1638333257.jpg) no-repeat
    center;
  background-size: 100%;
}

.carousel-inner {
  border-bottom: 1px solid #000;
}

.carousel-indicators {
  bottom: -40px;
}

.carousel-indicators li {
  background-color: #000000;
}

.carousel-item-img {
  border-top-left-radius: 0.8em;
  border-top-right-radius: 0.8em;
  background-color: transparent;
  box-shadow: 0px 0px 8px 3px #fff;
}

.border {
  display: inline-block;
  width: 70px;
  height: 70px;
  margin: 6px;
}

.jumbotron_a {
  color: #fff;
  background: #01b2c2;
}

.jumbotron_b {
  color: #fff;
  background: #3480fa;
}

.jumbotron_c {
  background: #f3f4f8;
}

.carousel-indicators li {
  width: 8px;
  height: 8px;
  background-color: #00cdc6;
}

.carousel-indicators .active {
  background-color: #00a4b7;
  width: 30px;
  height: 8px;
}

.label-primary {
  color: #3480fa;
  background-color: #dcdfe6;
}

.label-primary-j {
  color: #fff;
  background-color: #3b76fe;
  border-radius: 15px 0px 0px 0px;
}

.nav a {
  color: #01b2c2;
}

.imgsss {
  text-align: center;
  width: 100%;
  height: 70px;
  font-size: 16px;
  line-height: 35px;
  border: 1px solid #c0c0c0;
}

.label-primary-j1 {
  color: #fff;
  background-color: #91acbe;
  border-radius: 5px 0px 5px 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/views/web/bwg/list_zhi.vue